module.exports = __webpack_public_path__ + "static/img/product1.ee22ea60.png";